interface FetchConfiguration {
  baseURL: string;
  authToken?: string;
  locale?: string;
}

interface Configuration {
  fetch: FetchConfiguration;
}

interface Props {
  configuration: Configuration;
  children: React.ReactNode;
}

// This "DevServiceWorkerProvider" doesn't do anything, it just returns the children
// to prevent the service worker from throwing errors in development.
export const DevServiceWorkerProvider = ({ children }: Props) => {
  return children;
};
